// src/components/stamp/StampPreview.js - Container-based scaling
import React from 'react';
import Stamp, { STAMP_DIMENSIONS } from './Stamp';

/**
 * StampPreview Component - Uses explicit container sizing
 * Stamp fills container at 100% × 100%
 */
const StampPreview = ({ 
  config = {},       // Stamp configuration
  caseData = null,   // Case data object
  documentIndex = 0, // Zero-based document index (for preview, usually 0)
  scale = 1          // Scale for preview display
}) => {
  console.log('StampPreview rendering with:', { config, caseData, documentIndex, scale });
  
  // Calculate preview container size based on scale - ACTUAL dimensions
  const previewWidth = STAMP_DIMENSIONS.BASE_WIDTH * scale;
  const previewHeight = STAMP_DIMENSIONS.BASE_HEIGHT * scale;
  
  return (
    <div className="flex justify-center">
      {/* Outer container with actual scaled dimensions */}
      <div 
        className="relative"
        style={{
          width: `${previewWidth}px`,
          height: `${previewHeight}px`,
          overflow: 'hidden',
          filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1))',
          transition: 'all 0.2s ease'
        }}
      >
        {/* Inner wrapper that gets scaled - this makes borders/radius scale uniformly */}
        <div style={{
          transform: `scale(${scale})`,
          transformOrigin: '0 0',
          width: `${STAMP_DIMENSIONS.BASE_WIDTH}px`,
          height: `${STAMP_DIMENSIONS.BASE_HEIGHT}px`
        }}>
          <Stamp 
            config={config}
            caseData={caseData}
            documentIndex={documentIndex}
          />
        </div>
      </div>
    </div>
  );
};

export default StampPreview;